// @flow
import styled from 'styled-components';
import { mb, mt, py } from 'styled-components-spacing';
import { StyledCoverMaxWidthPadding } from '@components/Wrappers';
import { fontHeadingSubDark } from '@styles/typography';

import theme from '@theme';

const { colors } = theme;

export const StyledBreadCrumbsContainer = styled(StyledCoverMaxWidthPadding)`
  ${mt(4)}
  ${mb(0)}
`;

export const StyledTopHeadingWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const DisplayCount = styled.span`
  color: ${colors.grayText};
  font-style: italic;
  font-weight: 500;
  white-space: nowrap;
`;

export const StyledContentContainer = styled(StyledCoverMaxWidthPadding)`
  margin-top: 0;
  padding: 0 2rem;
  ${mb(6)}
`;

export const StyledArticleListHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${mb(4)}
  ${py(1)}
  border-bottom: solid 1px ${colors.separator};
  & > .title {
    ${fontHeadingSubDark}
    font-size: 28px;
  }
  & > .count {
    font-size: 18px;
    color: ${colors.darkBlue};
  }
`;
